export default "__VITE_ASSET__nU$8bPfd__"